import { gql } from '@apollo/client';

export const DELETE_ARBEITSBEREICH_STATION = gql`
  mutation mitarbeiter_deleteArbeitsbereichStation(
    $arbeitsbereichStationId: String!
  ) {
    mitarbeiter_deleteArbeitsbereichStation(
      arbeitsbereichStationId: $arbeitsbereichStationId
    ) {
      success {
        arbeitsbereichStationId
        details
      }
      error {
        message
      }
    }
  }
`;
